import React, { useEffect } from "react"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"
import styled from "styled-components"
// import { motion } from "framer-motion"
import Header from "../components/Header/header"
import Footer from "../components/Footer"
import Steps from "../components/Steps/Steps"
import Intro from "../components/Intro"
import SavingsSection from "../components/Calculator/SavingsSection"
import FeaturesSection from "../components/Features/FeaturesSection"

const IndexPage = () => {
  useEffect(() => {
    const script = document.createElement("script")

    script.src = "https://app.heyflow.co/pixel/buVT6QT2st9RnzHk"

    script.async = true

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [])

  return (
    <Wrapper>
      <SEO title="Prime Trust Prime IRA with Flora" />
      <Header />
      <main>
        <Intro />
        <Steps />
        <SavingsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-family: "Open Sans", sans-serif;

  margin: 0;
  overflow-x: hidden;
  .container {
    max-width: 1360px;
    p,
    li {
      font-size: 17pt;
      font-weight: 400;
    }
    h1 {
      font-size: 35pt;
      font-weight: 600;
    }
    h2 {
      font-size: 38pt;
      font-weight: 600;
    }
    h3 {
      font-size: 32pt;
      font-weight: 600;
    }
    h4 {
      font-size: 30pt;
      font-weight: 400;
    }
    h5 {
      font-size: 24pt;
      font-weight: 400;
    }

    h6 {
      font-size: 22pt;
      font-weight: 400;
    }
  }
`
export default IndexPage
